import {
	CompanyIdTypeSchema,
	withCompanyIdValidation,
	withConditionalGroups,
} from "@biteasy/contracts";
import z from "zod";

export const schema = withCompanyIdValidation(
	withConditionalGroups(
		z.object({
			name: z.string().min(2, "Name is required"),
			email: z.email("Email is required"),
			password: z.string().min(8, "Password is required"),
			country: z.string().min(1, "Country is required"),
			companyName: z.string(),
			companyIdType: CompanyIdTypeSchema,
			companyIdValue: z.string(),
		}),
		[["companyName", "companyIdType", "companyIdValue"]],
		{
			companyName: "Please provide your company name",
			companyIdType: "Please select an identifier type",
			companyIdValue: "Please provide your company identifier",
		},
	),
);

export type Schema = z.infer<typeof schema>;
export type SchemaInput = z.input<typeof schema>;
